import React from 'react';
import PropTypes from 'prop-types';

import { isEmpty, map } from 'lodash';
import {
  Box,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  Alert,
  List,
  ListItemText
} from '@mui/material';
import { Bert } from 'meteor/themeteorchef:bert';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import * as profileOps from '../../../api/Profiles/profiles-operations';

const ViewVideosProfiles = ({ profiles, profileSelect, handleProfile, match }) => {
  const [viewOneProfile, setViewOneProfile] = React.useState({});
  const [isPageNewProfile, setIsPageNewProfile] = React.useState(true);

  const finOneProfile = async () => {
    const profileId = match.params.profile_id;
    try {
      const findProfile = await methodPromise('profiles.findOne', profileId);
      setViewOneProfile(findProfile);
      setIsPageNewProfile(false);
    } catch (error) {
      handleErrorInClient(error);
      Bert.alert('There was an error searching the profile', 'danger');
    }
  };

  const showClasifyText = () => {
    const clasify = isPageNewProfile
      ? profileOps.getClasify(profileSelect)
      : profileOps.getClasify(viewOneProfile);
    let text = '';
    map(clasify, element => {
      text = `${text} ${element},`;
    });
    return text;
  };

  React.useEffect(() => {
    if (!isEmpty(match)) {
      const isPageProfile = match.path === '/videos/profiles/new';
      if (!isPageProfile) {
        finOneProfile();
      }
    }
  }, []);
  return (
    <>
      {isEmpty(profileSelect) && isEmpty(viewOneProfile) ? (
        <Alert severity="warning">No hay perfil para visualizar</Alert>
      ) : (
        <Box height={isPageNewProfile ? '100%' : '75vh'}>
          {!isEmpty(profiles) && (
            <FormControl
              style={{
                width: '100%'
              }}
              sx={{ mb: 2 }}
            >
              <InputLabel id="select-profile">Perfiles</InputLabel>
              <Select
                labelId="select-profile"
                id="select-profile"
                label="Profiles"
                defaultValue={profiles[0]}
                value={profileSelect}
                onChange={event => handleProfile(event)}
              >
                {profiles.map(profile => (
                  <MenuItem key={profileOps.getId(profile)} value={profile}>
                    {profileOps.getName(profile)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {!isPageNewProfile && !isEmpty(viewOneProfile) && (
            <h4>{profileOps.getName(viewOneProfile)}</h4>
          )}
          <iframe
            title="profile"
            src={
              isPageNewProfile
                ? profileOps.getPath(profileSelect)
                : profileOps.getPath(viewOneProfile)
            }
            width="100%"
            height="100%"
          />
          <Box style={{ display: 'flex', flexWrap: 'row' }}>
            <List>
              <ListItemText>
                {isPageNewProfile
                  ? `entwine: ${profileOps.getEntWineName(profileSelect)}`
                  : `entwine: ${profileOps.getEntWineName(viewOneProfile)}`}
              </ListItemText>
              <ListItemText>
                {isPageNewProfile
                  ? `buffer: ${profileOps.getBuffer(profileSelect)} metros`
                  : `buffer: ${profileOps.getBuffer(viewOneProfile)} metros`}
              </ListItemText>
              <ListItemText>{`clasificación: ${showClasifyText()}`}</ListItemText>
              <ListItemText>
                {isPageNewProfile
                  ? `url: ${profileOps.getPath(profileSelect)}`
                  : `url: ${profileOps.getPath(viewOneProfile)}`}
              </ListItemText>
            </List>
          </Box>
        </Box>
      )}
    </>
  );
};

ViewVideosProfiles.defaultProps = {
  profiles: [],
  handleProfile: () => {},
  match: {},
  profileSelect: {}
};
ViewVideosProfiles.propTypes = {
  profiles: PropTypes.array,
  profileSelect: PropTypes.object,
  handleProfile: PropTypes.func,
  match: PropTypes.object
};

export default ViewVideosProfiles;
